/**
 * Created by agengmaulana on 5/3/17.
 */
import React from 'react'
import 'moment/locale/id';
import styles from './../../assets/css/comment.css'

export default class Comment_Date extends React.Component {

    render(){
        var moment = require('moment');
        var convert = moment.unix(this.props.time).from();

        return(
            <span className={styles.cmt_dk_date}>{convert}</span>

        )
    }
}


// WEBPACK FOOTER //
// ./static/src/component/comment_date/comment_date.js